import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Eye, EyeOff, Pill } from 'lucide-react';
import useAuthStore from '../../store/authStore';
import { Button, Input } from '../../components/UI';
import { settingsService } from '../../api/services';
import toast from 'react-hot-toast';

export default function LoginPage() {
  const [form, setForm]               = useState({ email: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);
  const [settings, setSettings]       = useState({});
  const { login, isLoading }          = useAuthStore();
  const navigate                      = useNavigate();

  useEffect(() => {
    settingsService.getAll()
      .then(r => setSettings(r.data.settings || {}))
      .catch(() => {});
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.email || !form.password) return toast.error('Please fill all fields');
    const result = await login(form.email, form.password);
    if (result.success) { toast.success('Welcome back!'); navigate('/'); }
    else toast.error(result.message || 'Login failed');
  };

  const siteName = settings.company_name || 'PharmaCare';
  const siteLogo = settings.company_logo || null;

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="w-full max-w-sm">
        {/* Logo + Name */}
        <div className="text-center mb-8">
          {siteLogo ? (
            <img src={siteLogo} alt="logo" className="w-20 h-20 object-contain mx-auto mb-4 rounded-2xl"/>
          ) : (
            <div className="inline-flex items-center justify-center w-14 h-14 bg-blue-600 rounded-2xl mb-4 shadow-lg shadow-blue-200">
              <Pill size={28} className="text-white"/>
            </div>
          )}
          <h1 className="text-2xl font-bold text-gray-900">{siteName}</h1>
          <p className="text-sm text-gray-500 mt-1">Pharmacy Management System</p>
        </div>

        <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-8">
          <h2 className="text-lg font-semibold text-gray-900 mb-6">Sign in to your account</h2>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Email Address</label>
              <Input type="email" placeholder="email@pharmacy.com" value={form.email}
                onChange={e => setForm({ ...form, email: e.target.value })} autoComplete="email"/>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
              <div className="relative">
                <Input type={showPassword ? 'text' : 'password'} placeholder="Enter password"
                  value={form.password} onChange={e => setForm({ ...form, password: e.target.value })}
                  autoComplete="current-password" className="pr-10"/>
                <button type="button" onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600">
                  {showPassword ? <EyeOff size={16}/> : <Eye size={16}/>}
                </button>
              </div>
            </div>
            <Button type="submit" loading={isLoading} className="w-full mt-2" size="lg">Sign In</Button>
          </form>
        </div>
      </div>
    </div>
  );
}
